import { useListValidations } from "@/api/generated/validations/validations";
import { useCourseDetailStore } from "@/stores/courseDetailStore";

/**
 * Loads the learner's validations of the subchapter that holds a content
 * element. The quiz, worksheet and self-reflection hooks derive their state
 * from this one request and share its cache entry per subchapter. Nothing is
 * fetched outside an enrollment, for an element without a subchapter, or
 * while `enabled` is false; `isEnabled` tells the caller which it is.
 */
const useSubchapterValidations = (contentElementId: string, enabled = true) => {
  const store = useCourseDetailStore();
  const enrollmentId = store.enrollmentId ?? null;
  const subChapterId =
    store.nodeIndex?.get(contentElementId)?.subchapter?.id ?? null;

  const isEnabled = enabled && Boolean(enrollmentId) && Boolean(subChapterId);

  const query = useListValidations(
    { enrollment_id: enrollmentId ?? "", sub_chapter_id: subChapterId ?? "" },
    { swr: { enabled: isEnabled } }
  );

  return { ...query, isEnabled };
};

export { useSubchapterValidations };
